import { render } from "./TopBanner.vue?vue&type=template&id=6686afc6"
import script from "./TopBanner.vue?vue&type=script&lang=js"
export * from "./TopBanner.vue?vue&type=script&lang=js"

import "./TopBanner.vue?vue&type=style&index=0&id=6686afc6&lang=css"
script.render = render

export default script